module.exports = __webpack_public_path__ + "img/step4b-fr.d72f9035.webp";